'use strict';

angular.module('TurneroApp').component('coHeader', {
    bindings: {
        usuario: '<',
        centrosAtencion: '<',
        centroAtencionSeleccionado: '<',
        centroAtencionCallback: '&'
    },
    controller: [
        '$state',
        '$mdSidenav',
        'seguridadService',
        'TurneroAppConstant',
        'usuariosService',
        'utilsService',
        '$sessionStorage',
        '$localStorage',
        '$window',
        '$rootScope',
        'generalService',
        function ($state, $mdSidenav, seguridadService, TurneroAppConstant, usuariosService, utilsService, $sessionStorage, $localStorage, $window, $rootScope, generalService) {
            var ctrl = this;
            ctrl.constantes = TurneroAppConstant;
            ctrl.isOpenDialog = false;

            ctrl.home = function () {
                $rootScope.$broadcast('esHome', true);
                $rootScope.$broadcast('esCalendario', false);
                $rootScope.$broadcast('esTasaRetributiva', false);
                $window.location.href = "./turnos";
            };

            ctrl.openLeftMenu = function () {
                $mdSidenav('sidebar').toggle();
            };

            ctrl.logOut = function () {
                ctrl.logOutAtencion();
                seguridadService.logOut();
                seguridadService.removeCookies();
                delete $sessionStorage.TurneroApp_CentroSeleccionado;
                delete $localStorage.TurneroApp_Authorization;
                $window.location.href = $rootScope.urlHostServer + 'logout';
            };

            ctrl.logOutSinCerrarSesionCiDi = function () {
                ctrl.logOutAtencion();
                seguridadService.logOut();
                delete $sessionStorage.TurneroApp_CentroSeleccionado;
                delete $localStorage.TurneroApp_Authorization;

                generalService.Limpiar_Datos_Sin_Cerrar_Sesion_CiDi().$promise.then(function (result) {
                    $window.location.href = result.Data;
                }).catch(function (req) {
                    utilsService.errores(req);
                }); 
            };

            ctrl.openDialog = function () {
                ctrl.isOpenDialog = true;
            };

            ctrl.cambiarCentroDeAtencion = function (centroAtencionSeleccionado) {
                ctrl.centroAtencionCallback({ centroAtencionSeleccionado: centroAtencionSeleccionado });
                if (centroAtencionSeleccionado && centroAtencionSeleccionado.id) {
                    ctrl.logOutAtencion(centroAtencionSeleccionado.id);
                }

                $state.go('admin');

                ctrl.onCloseDialog();
            };

            ctrl.onCloseDialog = function () {
                ctrl.isOpenDialog = false;
            };

            ctrl.logOutAtencion = function (id_centro_atencion) {
                usuariosService.Post_Cerrar_Sesion_Centros({ 'id_centro_atencion': id_centro_atencion }).$promise.then(function (result) {
                    delete ($localStorage.TurneroApp_UsuarioSesion);
                }).catch(function (req) {
                    utilsService.errores(req);
                });
            }
        }],
    template: require('./header.html')
});



// WEBPACK FOOTER //
// ./app/shared/header/headerComponent.js